module.exports = __webpack_public_path__ + "jewelry-preview.png?fe08a8f002ebefbfcb9134a7c975a15a";